import React from 'react';
import './Developer.css';
export default function Developer() {


    return (
        <p className='Developer'>
            © Copyright 2025 Contacto +573004085041 catalogosco.top
        </p>
    );
}
